<script setup>
import { computed } from 'vue';
const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const routeName = computed(() => `${props.row.original.type}_reports_show`);
// Agent and label rows open their chart page (labels lost their sidebar link
// to it when the sidebar moved to the overview).
const isLinkRow = computed(() =>
  ['agent', 'label'].includes(props.row.original.type)
);
const isTeamHeader = computed(() => props.row.original.type === 'team-header');
</script>

<template>
  <span
    v-if="!isLinkRow"
    :class="
      isTeamHeader
        ? 'text-n-slate-11 font-semibold uppercase text-xs'
        : 'text-n-slate-12 font-bold'
    "
  >
    {{ row.original.name }}
  </span>
  <router-link
    v-else
    :to="{ name: routeName, params: { id: row.original.id } }"
    class="text-n-slate-12 hover:underline"
  >
    {{ row.original.name }}
  </router-link>
</template>
